import { Grid } from '@mui/material'
import React from 'react'
import { FieldContainer } from '../FieldContainer'
import { VerticalCheckboxes } from '../RegisterBrandForm/VerticalCheckboxes'

export const Verticals = ({ isEditing, verticalInitial }) => {
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <VerticalCheckboxes
            initialValues={isEditing ? verticalInitial : undefined}
          />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
